import angular from 'angular';

class FbService {
  /* @ngInject */
  constructor($window, $http, Session) {
    this.localStorage = $window.localStorage;
    this.$http = $http;
    this.Session = Session;
    this.url = 'https://graph.facebook.com/v14.0/1752272581455417/events?access_token=EAAQseKZBSErMBAGZAO08GmUnGHKEEonpst96tgzSOvhuKPtvBjijlr10nJiNWNWhmoqw6r1vez3hFr3C4NB89iT8Rfzv3ZAjZCEGIlJxCcAZAPjsYGHNlCHJWF24OnlkZAhtG9vh9kWPEVNfnYL0Sc65Qu8Bxoqz2X2r2ZBXfyRp0L3soYWpJL3';

  }

  deviceCalc() {
    if (window.screen.width <= 576) {
      return 'Mobile';
    } else if (window.screen.width > 576 && window.screen.width < 800) {
      return 'Tab';
    }
    return 'Web';
  }

  getUserInfo() {
    const user = this.Session.read('userinfo');
    if (user) {
      return user.id;
    }
    return null;
  }

  eventEmitter(event, customData) {
    const fullUrl = window.location.href;
    // if (fullUrl.includes('.test') || fullUrl.includes('staging-')) return;
    const date = new Date();
    const unixTimestamp = Math.floor(date.getTime() / 1000);

    customData.platform = this.deviceCalc();

    const data = {
      data: [
        {
          event_name: event,
          event_time: unixTimestamp,
          user_data: {
            client_user_agent: this.getUserInfo(),
            client_ip_address: '192.88.9.9',
          },
          custom_data: customData,
          opt_out: true,
        },
      ],
    };

    this.$http
      .post(this.url, data)
      .then((res) => {
      });
  }
}

export default FbService;




// WEBPACK FOOTER //
// ./client/components/auth/fb/fb.service.js